import React from "react";
import store from "../../state/store";

export const steps = [
  {
    target: ".wizard-Classify-button",
    content: `You can contribute to the community by classifying the current variant
    (as Benign, Pathogenic etc).
    You may optionally add related diseases/phenotypes and your comments to the classification.`,
    disableBeacon: true,
    apiVersion: "6.3.1",
  },
  {
    target: ".wizard-resultsScroller",
    content:
      "Data sources with data for this variant. Click to jump to this source. Overall VarSome aggregates data from more than 120 databases",
    disableBeacon: true,
    apiVersion: "6.3.1",
  },
  {
    target: ".wizard-searchInput",
    content: (
      <div>
        You can search by various formats (see{" "}
        <a target="_blank" href="/about/examples/">
          Examples
        </a>{" "}
        for a complete description).
        <br />
        Variants:
        <br />
        <a
          target="_blank"
          href={`${store.getState().varsomeHost}/variant/hg19/BRAF V600E`}
        >
          BRAF V600E
        </a>
        <br />
        <a
          target="_blank"
          href={`${store.getState().varsomeHost}/variant/hg19/BRAF c.1799T>A`}
        >
          BRAF c.1799T&gt;A
        </a>
        <br />
        <a
          target="_blank"
          href={`${
            store.getState().varsomeHost
          }/variant/hg19/chr7-140453136-A-T`}
        >
          chr7-140453136-A-T
        </a>
        <br />
        Genes and transcripts:
        <br />
        <a target="_blank" href={`${store.getState().varsomeHost}/gene/BRAF`}>
          BRAF
        </a>
        <br />
        <a
          target="_blank"
          href={`${store.getState().varsomeHost}/transcript/hg19/NM_004333`}
        >
          NM_004333
        </a>
        <br />
        Positions:
        <br />
        <a
          target="_blank"
          href={`${store.getState().varsomeHost}/variant/hg19/BRAF c.1799`}
        >
          BRAF c.1799
        </a>
        <br />
        <a
          target="_blank"
          href={`${store.getState().varsomeHost}/position/hg19/chr7-140453136`}
        >
          chr7-140453136
        </a>
      </div>
    ),
    disableBeacon: true,
    apiVersion: "6.3.1",
  },
  {
    target: ".wizard-searchButtonHeader",
    content:
      "Annotates the variant using Germline databases and Germline Variant Classification or by using additional cancer databases and AMP (for VarSome Premium users only).",
    disableBeacon: true,
    apiVersion: "9.2.1",
  },
  {
    target: ".wizard-Clinvar",
    content: "Submit variant information to ClinVar",
    disableBeacon: true,
    apiVersion: "10.2",
  },
  {
    target: ".wizard-HelpModalInitiator",
    content: "Help on how to use “Cards View”",
    disableBeacon: true,
    apiVersion: "11.2.1",
  },
  {
    target: ".wizard-layoutOptions",
    content: "Configure card layout",
    disableBeacon: true,
    apiVersion: "11.2.2",
  },
  {
    target: "[data-wizard='generalInfoCard']",
    content:
      "Cards show key information at a glance. Click a card to load the detailed information.",
    disableBeacon: true,
    apiVersion: "11.2.3",
  },
];
